import { ProductQuoteV3Dimension } from '@orus.eu/dimensions'
import type { MrpaQuote, QuoteModelInput } from '@orus.eu/pricing'

export class MrpaQuoteDimension<NAME extends string> extends ProductQuoteV3Dimension<
  NAME,
  1,
  QuoteModelInput,
  MrpaQuote
> {}

export const mrpaQuoteDimension = new MrpaQuoteDimension({
  name: 'mrpaQuote',
  displayKeys: { name: 'dimension_name_mrpa_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
